!function ($) {
    "use strict";

    var FormWizard = function () {};

    FormWizard.prototype.createBasic = function ($form_container) {
        $form_container.children("div").steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "slideLeft",
            onFinishing: function (event, currentIndex) {
                //NOTE: Here you can do form validation and return true or false based on your validation logic
                console.log("Form has been validated!");
                return true;
            },
            onFinished: function (event, currentIndex) {
                //NOTE: Submit the form, if all validation passed.
                console.log("Form can be submitted using submit method. E.g. $('#basic-form').submit()");
                $("#basic-form").submit();

            }
        });
        return $form_container;
    },
    //creates form with parsley validation
    FormWizard.prototype.createParsleyValidatorForm = function ($formContainer) {
        $formContainer.parsley();

        $formContainer.children("div").steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "slideLeft",
            onStepChanging: function (event, currentIndex, newIndex) {
                if (currentIndex < newIndex) {
                    //Validate when going forward
                    $formContainer.parsley({
                        excluded: ':disabled, :hidden'
                    }).validate();

                    return $formContainer.parsley().isValid();
                }

                return true;
            },
            onFinishing: function (event, currentIndex) {
                $formContainer.parsley({
                    excluded: ':disabled'
                }).validate();

                return $formContainer.parsley().isValid();
            },
            onFinished: function (event, currentIndex) {
                $formContainer.submit();
            }
        });

        return $formContainer;
    },
    //creates vertical form
    FormWizard.prototype.createVertical = function ($form_container) {
        $form_container.steps({
            headerTag: "h3",
            bodyTag: "section",
            transitionEffect: "fade",
            stepsOrientation: "vertical"
        });
        return $form_container;
    },
    FormWizard.prototype.init = function () {
        //initialzing various forms

        //basic form
        this.createBasic($("#basic-form"));

        // form with parley validation
        if ($('.wizard-parsley-form').length > 0) {
            this.createParsleyValidatorForm($('.wizard-parsley-form'));
        }

        //vertical form
        this.createVertical($("#wizard-vertical"));
    },
    //init
    $.FormWizard = new FormWizard, $.FormWizard.Constructor = FormWizard;
}(window.jQuery),

//initializing
function ($) {
    "use strict";
    $.FormWizard.init();
}(window.jQuery);
